import { SimpleForm, useRecordContext } from 'react-admin';
import { FCRAWorkerAdverse } from '@/types/turn-api';
import FormContent from './FormContent';
import { AdverseEditDisputeProps } from './types';

const AdverseEditDispute = (props: AdverseEditDisputeProps) => {
  const record = useRecordContext<FCRAWorkerAdverse.Details>();
  const formRecord = {
    adverse: {
      dispute: record?.adverse?.dispute ? 1 : 0,
      comments: record?.adverse?.comments ?? null,
    },
  };

  return (
    <SimpleForm mode="onChange" reValidateMode="onChange" record={formRecord} toolbar={false}>
      <FormContent {...props} />
    </SimpleForm>
  );
};

export default AdverseEditDispute;
